import React from 'react';
import Styles from './my-modules-student-styles.scss';
import HeaderModules from './components/header-modules/header-modules';
import { CircleLoader, ProgressBar } from '@/presentation/components';
import ModuleItem from './components/module-item/module-item';
import { useNavigate, useParams } from 'react-router';
import { useMyModulesStudent } from '@/presentation/hooks';
import ModuleCurrentItem from './components/module-current-item/module-current-item';
import { MountainIcon } from '@/presentation/components/icons';
const getRandomColor = (indexParam) => {
    const colors = ['blue', 'green', 'purple', 'orange', 'red'];
    const colorIndex = indexParam % colors.length;
    return colors[colorIndex];
};
const MyModulesStudent = ({ loadKeywords, loadModules }) => {
    const navigate = useNavigate();
    const { loading, modules, cumulativeScore, currentProgress } = useMyModulesStudent({
        loadKeywords,
        loadModules
    });
    const { idStudent } = useParams();
    const handleOnContinue = () => {
        const findCurrentModule = modules.find(module => module === null || module === void 0 ? void 0 : module.currentModule);
        if (findCurrentModule)
            navigate(`/school-dashboard/my-modules/${findCurrentModule === null || findCurrentModule === void 0 ? void 0 : findCurrentModule.id}/student/${idStudent}`);
    };
    const setItemByStatus = (module, index) => {
        if (module === null || module === void 0 ? void 0 : module.currentModule) {
            return (React.createElement(ModuleCurrentItem, { key: module === null || module === void 0 ? void 0 : module.id, backgroundColor: getRandomColor(index), icon: React.createElement(MountainIcon, null), type: "in-progress", onClick: () => navigate(`/school-dashboard/my-modules/${module === null || module === void 0 ? void 0 : module.id}/student/${idStudent}`), module: {
                    moduleTitle: `Module ${index + 1}`,
                    title: module === null || module === void 0 ? void 0 : module.name,
                    description: module === null || module === void 0 ? void 0 : module.summary,
                    completed: false,
                    progress: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) || 0,
                    score: (module === null || module === void 0 ? void 0 : module.studentScoreInModulePercent) || 0
                } }));
        }
        return (React.createElement(ModuleItem, { key: module === null || module === void 0 ? void 0 : module.id, backgroundColor: getRandomColor(index), type: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) === 100 ? 'completed' : 'blocked', onClick: () => navigate(`/school-dashboard/my-modules/${module === null || module === void 0 ? void 0 : module.id}/student/${idStudent}`), module: {
                moduleTitle: `Module ${index + 1}`,
                title: module === null || module === void 0 ? void 0 : module.name,
                completed: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) === 100,
                progress: (module === null || module === void 0 ? void 0 : module.studentProgressInModulePercent) || 0,
                score: (module === null || module === void 0 ? void 0 : module.studentScoreInModulePercent) || 0,
                description: module === null || module === void 0 ? void 0 : module.summary
            } }));
    };
    return (React.createElement("div", { className: Styles.myModulesWrap },
        React.createElement("div", { className: Styles.content },
            React.createElement(HeaderModules, { percentage: cumulativeScore || 0, onContinue: handleOnContinue, disabled: true }),
            loading ? (React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '20%'
                } },
                React.createElement(CircleLoader, null))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: Styles.progressBarContent },
                    React.createElement(ProgressBar, { backgroundColor: "green", percentage: currentProgress })),
                React.createElement("div", { className: Styles.modulesGrid }, modules.map((module, index) => setItemByStatus(module, index))))))));
};
export default MyModulesStudent;
